import { render, staticRenderFns } from "./mwithdrawal.vue?vue&type=template&id=40717bda&scoped=true"
import script from "./mwithdrawal.vue?vue&type=script&lang=js"
export * from "./mwithdrawal.vue?vue&type=script&lang=js"
import style0 from "./mwithdrawal.vue?vue&type=style&index=0&id=40717bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40717bda",
  null
  
)

export default component.exports